import React, { useCallback, useContext } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { getKeyFromEnumValue } from '../../utils/utils'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { typeCandidatureEnum } from './enums/changementAppartementEnum'
import Button from '../../components/button/Button'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { ResponsiveContext } from '../../utils/context/responsiveContext'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { redirectionVersAcquisitionResidence } from './utils/changementAppartementUtils'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean }>(
	(theme) => ({
		...styles(theme),
		conteneurChangementAppartementEnCours: {
			marginBottom: props => props.isLargeScreen ? 40 : 35
		}
	})
)

const ChangementAppartementEnCours = () => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen })
	const dossier = useSelector((state: RootState) => state.dossier)
	const intl = useIntl()

	const titleClass: ClassValue = classNames(
		isLargeScreen ? classes.title2 : classes.title6,
		classes.colorBlue
	)

	const consulterDemande = useCallback(() => redirectionVersAcquisitionResidence(intl.locale), [intl.locale])

	return (
		<Grid container item xs={12} className={classes.conteneurChangementAppartementEnCours}>
			<Grid item xs={12}>
				<h1 className={titleClass}>
					<FormattedMessage
						id={`changementAppartement.enCours.titre.${getKeyFromEnumValue<typeCandidatureEnum>(typeCandidatureEnum, dossier!.eft_type_de_candidature)}`}
						defaultMessage="Votre demande de location d'appartement"
						description="Titre du bloc changement appartement en cours"
					/>
				</h1>
			</Grid>

			<Grid item xs={12} md={4}>
				<Button
					background="backgroundGreen"
					color="colorWhite"
					textStyle="text8"
					onClick={consulterDemande}
				>
					<FormattedMessage
						id="changementAppartement.enCours.bouton"
						defaultMessage="Consulter votre demande"
						description="Bouton pour consulter la demande de dossier"
					/>
				</Button>
			</Grid>
		</Grid>
	)
}

export default ChangementAppartementEnCours
